import React, { useEffect, useState } from "react";
import styles from "./AllDevices.module.css";
import useAuthToken from "../../../hooks/useAuthToken";
import { useNavigate } from "react-router-dom";
import { fetchDeviceService, fetchCommandInDevice } from "./fetchDeviceService";
import config from "../../../settings/config";
import led from "../../../img/relay-no-bg.png";
import profileIcon from "../../../img/profileIcon.svg";
import { useToast } from "../../../context/ToastContext";
import useBackendStatus from "../../../hooks/useBackendStatus";

const AllDevices = () => {
    const [devices, setDevices] = useState([]);
    // const [loading, setLoading] = useState(true);
    const { setToast } = useToast();
    const token = useAuthToken();
    useBackendStatus();
    const navigate = useNavigate();
    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    const handleAddDevice = () => {
        navigate("/add-device");
    };

    const handleProfile = () => {
        // showToast("Профиль пока не доступен", "warn", 3000 );
        navigate("/profile");
    };

    useEffect(() => {
        fetchDevices(); // Вызываем сразу при монтировании

        const interval = setInterval(() => {
            fetchDevices();
        }, 10000); // 10 секунд

        return () => clearInterval(interval); // Очищаем интервал при размонтировании
    }, [token]);

    async function fetchDevices() {
        if (!token) return;
        const resp = await fetchDeviceService(token);
        console.log(resp)
        if (resp) setDevices(resp);
    }

    const handleSendCommandToggle = (device) => {
        if (!device.isAlive) {
            showToast("Устройство не в сети", "warn", 3000)
            return;
        }
        fetchCommandInDevice(token, device.sn, device.slaves[0].id, "toggle", "1")
            .then(() => {
                setDevices(prevDevices =>
                    prevDevices.map(d =>
                        d.id === device.id
                            ? {
                                ...d,
                                slaves: d.slaves.map(slave =>
                                    slave.id === device.slaves[0].id
                                        ? { ...slave, value: slave.value === "1" ? "0" : "1" }
                                        : slave
                                )
                            }
                            : d
                    )
                );
            });
    }

    return (
        <div className={styles.container}>
            <div className={styles.mainSection}>
                <h3>Ваши устройства</h3>
                {devices.length === 0 ? (
                    <p className={styles.noDevices}>Нет устройств</p>
                ) : (
                    <div className={styles.devices}>
                        {devices
                            .slice() // Клонируем массив, чтобы не изменять оригинал
                            .sort((a, b) => a.id - b.id) // Сортируем по id в порядке возрастания
                            .map((device, index) => (
                                <div key={index} className={device.isAlive ? styles.deviceItem : styles.deviceItemOff}>
                                    {device.type === "sensor" ? (
                                        <div className={styles.sensorGrid}>
                                            {[0, 1, 2, 3].map((i) => (
                                                <div key={i} className={styles.sensorCell}>
                                                    <p className={styles.sensorText}>
                                                        {`${device.slaves[i]?.value ?? 0} ${device.slaves[i]?.units ?? ""}`}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}
                                    {device.type === "relay" ? (
                                        <div className={styles.relay}>
                                            <img className={styles.deviceImg} src={led} alt="led" />
                                            <div className={styles.deviceInfo}>
                                                <p className={styles.deviceName}>{device.name}</p>
                                                <div
                                                    className={device?.slaves[0]?.value === "1" ? styles.statusOn : styles.statusOff}
                                                    onClick={() => handleSendCommandToggle(device)}>
                                                    <div className={styles.switch} />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    {device.type === "combo" ? (
                                        <div className={styles.relay}>
                                            <img className={styles.deviceImg} src={led} alt="led" />
                                            <div className={styles.deviceInfo}>
                                                <p className={styles.deviceName}>{device.name}</p>
                                                <div
                                                    className={device?.slaves[0]?.value === "1" ? styles.statusOn : styles.statusOff}
                                                    onClick={() => handleSendCommandToggle(device)}>
                                                    <div className={styles.switch} />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ))}
                    </div>
                )}
            </div>
            <div className={styles.button}>
                <div className={styles.buttonsBg}>
                    <button
                        className={styles.buttonProfile}
                        onClick={handleProfile}
                    >
                        <img className={styles.profileImg} src={profileIcon} alt="profile"></img>
                    </button>
                    <button
                        className={styles.buttonAdd}
                        onClick={handleAddDevice}
                    >
                        Добавить устройство
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AllDevices;